module.exports = __webpack_public_path__ + "static/media/Akagera-zebra.661b50c6.jpg";